{
  "conversations": {
    "conversationsApp": "Samtaler-app",
    "locationId": "Steds-ID",
    "idToken": "ID-token",
    "conversationRoutes": "Samtaleruter",
    "conversationProviders": "Samtaleleverandører",
    "viewTheListOfConversation": "Se Liste av samtalen Tilpasset-leverandører lagt til på Konto her.",
    "logo": "Logo",
    "name": "Navn",
    "alias": "Alias",
    "type": "Type"
  }
}
